import { buildCommonTelecomContractParameters } from '../buildCommonTelecomContractParameters'

export const contractSaveParametersGeneration = ({
  type,
  contractId,
  contactId,
  addressId,
  contractData,
  characteristicsData,
  contactPreferences,
  action = 'save',
}) => {
  const options = buildCommonTelecomContractParameters({
    type,
    contractId,
    contactId,
    addressId,
    contractData,
    characteristicsData,
    action,
  })

  options.append(
    'providers_options',
    contractData.providerOptions?.length > 0
      ? JSON.stringify(contractData.providerOptions.map(option => option.id))
      : JSON.stringify([]),
  )

  if (contractData.businessCard !== undefined) {
    options.append('business_card', contractData.businessCard === 1 ? '1' : '0')
  }

  if (contactPreferences.createReviewsInteraction) {
    options.append('create_reviews_interaction', '1')
  }

  return options
}
